import React, { useContext, useState } from 'react';
import '../../App.css'
import { Button, Container, List, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import TextField from '@mui/material/TextField';
import api from '../../connection/Axios';


const AdicionarAdmin = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState()
  const [success, setSuccess] = useState(true)
  const role = 'admin'

  function ValidateEmail() {
    var re = /\S+@\S+\.\S+/;
    if (re.test(email) === true) {
        console.log('valida email passed')
        SaveAdmin()
    } else {
        setSystemData({...systemData, erro : 'Digite um email válido', typeError : 'error'})
    }
  }

  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};

  const data = {
    "username": email,
    "name": name,
    "password": password, 
    "active": true,
    "role": role,
    "companyId": '1'
  }


  function Reset() {
    setEmail('')
    setName('')
    setSuccess(true)
  }

  async function SaveAdmin() {
    await api.post('register/createUserTemp/', data, headers).then(response => {
      console.log(JSON.stringify(response.data))
      setSuccess(false)
    }).catch(error => {
      setSystemData({...systemData, erro: error.message, typeError: 'warning'})
    })
  }


  return (
    <>
        <Layout breadcrumb='Dashboard / Administradores / Adicionar usuário admin' title='Adicionar Usuário Admin'>
          <Typography>Preencha os campos abaixo para criar um novo usuário com privilégios de ADMINISTRADOR:</Typography>
          <br />
          {success ?
          <>
            <div style={styles.block}></div>
            <TextField  onChange={(event) => setName(event.target.value)} value={name} label="Nome" variant="outlined" />
            
            <div style={styles.block}></div>
            <TextField  onChange={(event) => setEmail(event.target.value)} value={email} label="E-mail" variant="outlined" />
            
            <div style={styles.block}></div>
            <TextField  onChange={(event) => setPassword(event.target.value)} value={password} label="Senha" type='password' variant="outlined" />

            <div style={styles.block}>
              <Button variant="contained" color='secondary' className='boto' style={{color: '#ffffff'}} onClick={()=>{ValidateEmail()}}>
                Adicionar
              </Button>
            </div>
          </>  
          :
          <>
            <div style={styles.block}></div>
            Usuário administrador criado com sucesso.
            <div style={styles.block}></div>
            <span style={{fontWeight: 600}}>Nome: </span> {name}
            <span style={{fontWeight: 600}}>E-mail: </span> {email}
            <div style={styles.block}></div>
            <div style={styles.block}></div>
            <Button variant="contained" className='boto' style={{color: '#ffffff'}} onClick={()=>{Reset()}}>
              Cadastrar novo usuário
            </Button>
          </>
          }
        </Layout>
    </>
  );
};

export default AdicionarAdmin

const styles = {
  block: {
    marginTop: 10,
  }
}